import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import { AppState } from 'services/types';
import { Entity, EntityId } from 'services/entities/types';
import { makeSelectOrderedSectors } from 'components/PersonForm/selectors';
import { OwnProps } from './index';

const selectEntityId = (state: AppState, props: OwnProps): EntityId =>
    props.entityId;

const selectEntityNameById = createDeepEqualSelector(
    makeSelectOrderedSectors(),
    selectEntityId,
    (sectorEntities: Entity[], entityId: EntityId) =>
        sectorEntities?.find((entity: Entity) => entity?.id === entityId)
            ?.name ?? ''
);

const makeSelectEntityNameById = (): typeof selectEntityNameById =>
    selectEntityNameById;

export { selectEntityId, makeSelectEntityNameById };
